<template>
  <router-view />
</template>
<script>
import { Options, Vue } from 'vue-class-component';
@Options({ name: 'App' })
export default class App extends Vue {}
</script>
<style lang="scss"></style>
